var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 14.2989 15.0804",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6289 7.11148L7.50222 13.2381C6.75166 13.9887 5.73368 14.4104 4.67222 14.4104C3.61077 14.4104 2.59279 13.9887 1.84222 13.2381C1.09166 12.4876 0.67 11.4696 0.67 10.4081C0.67 9.34669 1.09166 8.32871 1.84222 7.57815L7.96889 1.45148C8.46927 0.951108 9.14792 0.67 9.85556 0.67C10.5632 0.67 11.2419 0.951108 11.7422 1.45148C12.2426 1.95186 12.5237 2.63051 12.5237 3.33815C12.5237 4.04579 12.2426 4.72444 11.7422 5.22482L5.60889 11.3515C5.3587 11.6017 5.01938 11.7422 4.66556 11.7422C4.31174 11.7422 3.97241 11.6017 3.72222 11.3515C3.47204 11.1013 3.33148 10.762 3.33148 10.4081C3.33148 10.0543 3.47204 9.715 3.72222 9.46482L9.38222 3.81148",
    stroke: "currentColor",
    strokeWidth: 1.34,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.ce25338936c7dfac2fcb15fc59186a19.svg";
export { ForwardRef as ReactComponent };